import * as React from 'react';
import styled from 'styled-components';
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import Option from '../../models/Option';
import FieldDecorator from './FieldDecorator';
import { ChangeableValue } from './Input';
import { customiseErrorMessageForKendoField, setFormFieldErrorMessage } from '../../lib/utils';
import './fieldStyles.less';
import '../commonComponents.less';
import { blueyGrey, fieldBackgroundWhite } from '../../appComponents/cssConstants';

const ComboBoxField = (props: Props) => {
	const [data, setData] = React.useState<string[] | Option<string>[]>(props.data);

	React.useEffect(() => {
		const waitDomRenderInMilliSeconds = 1000;
		setTimeout(customiseErrorMessageForKendoField, waitDomRenderInMilliSeconds);
	}, []);

	const handleSelect = (event: ComboBoxChangeEvent) => {
		setFormFieldErrorMessage(event.target.element);
		const { value } = event.target;
		props.onValueChange(props.name, value, null);
	};

	const filterChange = (event: ComboBoxFilterChangeEvent) => {
		const allData = props.data;
		setData(filterBy(allData as string[], event.filter));
	};

	const getActualValue = () => {
		const { value } = props;
		if (!value) return value;
		return data && data[0] && (data[0] as Option<string>).value && !(value as Option<string>).value
			? (data as Option<string>[]).find((x) => x.value === value)
			: value;
	};

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { onValueChange, label, value, className, errorMessage = null, ...rest } = props;

	return (
		<FieldDecorator label={label} className={className} errorMessage={errorMessage}>
			<ComboBoxWrapper>
				<ComboBox
					// eslint-disable-next-line react/jsx-props-no-spreading
					{...rest}
					data={data}
					value={getActualValue()}
					onChange={handleSelect}
					popupSettings={{ className: props.className }}
					onFilterChange={filterChange}
				/>
			</ComboBoxWrapper>
		</FieldDecorator>
	);
};

export default ComboBoxField;

interface Props extends ChangeableValue {
	label: string;
	name: string;
	className?: string;
	textField?: string;
	dataItemKey?: string;
	data: string[] | Option<string>[];
	value: string | Option<string>;
	required?: boolean;
	filterable?: boolean;
	errorMessage?: string;
}

ComboBoxField.defaultProps = {
	className: '',
	textField: '',
	dataItemKey: '',
	required: false,
	filterable: false,
	errorMessage: null
};

export const ComboBoxWrapper = styled.div`
	.k-combobox {
		display: flex;
		border-radius: 8px;
		border-color: ${blueyGrey};

		.k-dropdown-wrap {
			border-radius: 7px;
			background: ${fieldBackgroundWhite};

			.k-clear-value {
				top: 6px;
			}

			.k-searchbar {
				background: ${fieldBackgroundWhite};
			}

			input {
				font-size: 18px;
				font-weight: normal;
			}
		}
	}
`;
